<template>
  <basic-container>
    <avue-crud
        :option="option1"
        :data="data1"
        ref="crud"
        v-model="form1"
        :permission="permissionList"
        @row-del="rowDel"
        @row-update="rowUpdate"
        @row-save="rowSave1"
        :before-open="beforeOpen"
        :page.sync="page1"
        @refresh-change="refreshChange"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        :header-cell-class-name="headerCellClassName"
        @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.sys_user_delete"
            @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>

    <avue-crud
        :option="option2"
        :data="data2"
        ref="crud"
        v-model="form2"
        :permission="permissionList"
        @row-del="rowDel"
        @row-update="rowUpdate"
        @row-save="rowSave2"
        :before-open="beforeOpen"
        :page.sync="page2"
        @refresh-change="refreshChange"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        :header-cell-class-name="headerCellClassName"
        @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            v-if="permission.sys_user_delete"
            @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, remove, submit } from '@/api/health/ChannelVipConfig'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form1: {},
      form2: {},
      selectionList: [],
      page1: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      init: {
        roleTree: [],
        deptTree: []
      },
      headerCellClassName: 'headerClass',
      option1: {
        tip: false,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogHeight: 450,
        searchMenuSpan: 4,
        column: [
        {
            label: '渠道名称',
            prop: 'channel',
            type: 'tree',
            dicUrl: '/sys/channel/dict',
            dataType: 'string',
            rules: [{
              required: true,
              message: '请选择所属渠道',
              trigger: 'click'
            }]
          },
          {
            label: '总次数',
            prop: 'totalFrequency',
            editDisabled: true,
            search: true,
            searchSpan: 4,
            rules: [{
              required: true,
              message: '请输入总次数'
            }]
          },
          {
            label: '剩余次数',
            prop: 'surplusFrequency',
            addDisplay: false,
            editDisabled: true,
            search: true,
            searchSpan: 4,
          },
          {
            label: '是否开启',
            prop: 'open',
            type: 'select',
            dicData: [
              { label: '已终止', value: 0 },
              { label: '使用中', value: 1 }
            ]
          },
          {
            label: '会员类型',
            prop: 'vipType',
            type: 'select',
            editDisabled: true,
            dicData: [
              { label: '普通用户', value: 0 },
              { label: '基础会员', value: 1 },
              { label: '体验会员', value: 2 },
              { label: '全年会员', value: 3 },
              { label: '月度会员', value: 4 },
              { label: '季度会员', value: 5 },
              { label: 'vip会员', value: 6 }
            ]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            addDisplay: false,
            editDisabled: true,
            cell: false
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            addDisplay: false,
            editDisabled: true,
            cell: false
          }
        ]
      },
      option2: {
        tip: false,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogHeight: 450,
        searchMenuSpan: 4,
        column: [
        {
            label: '医院名称',
            prop: 'hospital',
            type: 'tree',
            dicUrl: '/health/doctorHospital/dict',
            dataType: 'string',
            rules: [{
              required: true,
              message: '请选择所属渠道',
              trigger: 'click'
            }]
          },
          {
            label: '总时间',
            prop: 'totalTime',
            editDisabled: true,
            search: true,
            searchSpan: 4,
            width: 90,
            rules: [{
              required: true,
              message: '请输入总次数'
            }]
          },
          {
            label: '剩余时间',
            prop: 'surplusTime',
            addDisplay: false,
            editDisabled: true,
            search: true,
            searchSpan: 4,
            width: 90,
          },
          {
            label: '是否开启',
            prop: 'open',
            type: 'select',
            dicData: [
              { label: '已终止', value: 0 },
              { label: '使用中', value: 1 }
            ]
          },
          {
            label: '会员类型',
            prop: 'vipType',
            type: 'select',
            editDisabled: true,
            dicData: [
              { label: '普通用户', value: 0 },
              { label: '基础会员', value: 1 },
              { label: '体验会员', value: 2 },
              { label: '全年会员', value: 3 },
              { label: 'vip会员', value: 6 }
            ]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            addDisplay: false,
            editDisabled: true,
            cell: false
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            addDisplay: false,
            editDisabled: true,
            cell: false
          }
        ]
      },
      data1: [],
      data2: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.sys_user_add, false),
        viewBtn: this.vaildData(this.permission.sys_user_view, false),
        delBtn: this.vaildData(this.permission.sys_user_delete, false),
        editBtn: this.vaildData(this.permission.sys_user_edit, false)
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave1 (row, loading, done) {
      row.surplusFrequency = row.totalFrequency
      row.type = 1
      submit(row).then(() => {
        loading()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowSave2 (row, loading, done) {
      row.surplusTime = row.totalTime
      row.type = 2
      submit(row).then(() => {
        loading()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowUpdate (row, index, loading, done) {
      submit(row).then(() => {
        loading()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.onLoad(this.page, params, done)
    },
    selectionChange (list) {
      this.selectionList = list
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },
    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    refreshChange (data) {
      this.onLoad(this.page, data.searchForm)
    },
    currentChange (currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize
    },
    onLoad (page, params = {}, done) {
      getList(this.page1.currentPage, this.page1.pageSize, { type: 1 }).then(res => {
        console.log('test getList')
        console.log(res)
        const data = res.data
        this.page1.total = data.total
        this.data1 = data.records
        if (done) {
          done()
        }
      })
      getList(this.page2.currentPage, this.page2.pageSize, { type: 2 }).then(res => {
        console.log('test getList')
        console.log(res)
        const data = res.data
        this.page2.total = data.total
        this.data2 = data.records
        if (done) {
          done()
        }
      })
    }
  }
}
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
